import type { useI18n } from '@affine/i18n';

type I18n = ReturnType<typeof useI18n>;

type ImportCountUnit = 'file' | 'sheet' | 'row' | 'column' | 'database';

function importCountKey(unit: ImportCountUnit, count: number) {
  const variant = count === 1 ? 'one' : 'many';
  return `com.streamlain.import.preview.count.${unit}.${variant}` as const;
}

export function formatImportCount(
  t: I18n,
  unit: ImportCountUnit,
  count: number
): string {
  return t[importCountKey(unit, count)]({ count: String(count) });
}

export function formatImportFilesSelected(t: I18n, count: number): string {
  const key =
    count === 1
      ? 'com.streamlain.import.preview.files-selected.one'
      : 'com.streamlain.import.preview.files-selected.many';
  return t[key]({ count: String(count) });
}

export function formatImportMoreRows(t: I18n, count: number): string {
  const key =
    count === 1
      ? 'com.streamlain.import.preview.more-rows.one'
      : 'com.streamlain.import.preview.more-rows.many';
  return t[key]({ count: String(count) });
}
